import { useState, useEffect } from "react";
import { fetchUserAttributes } from "aws-amplify/auth";
import { useNavigate } from "react-router-dom";

function getGreeting() {
  const h = new Date().getHours();
  if (h < 12) return "Good morning";
  if (h < 17) return "Good afternoon";
  return "Good evening";
}

const today = new Date().toLocaleDateString("en-US", {
  weekday: "long", year: "numeric", month: "long", day: "numeric"
});

const features = [
  {
    label: "Membership Fulfillment",
    description: "Track promotional membership transactions from Blackbaud through to physical fulfillment. Upload CSVs, manage status, generate letters.",
    accent: "#FF5F05",
    border: "rgba(255,95,5,0.2)",
    to: "/fulfillment",
    live: true,
    span: 2,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" style={{width:28,height:28}}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 0 0-3.213-9.193 2.056 2.056 0 0 0-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 0 0-10.026 0 1.106 1.106 0 0 0-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" />
      </svg>
    ),
  },
  {
    label: "ID Matching",
    description: "Match alumni email addresses to BBCRM Constituent IDs. Upload a list, get back a matched Excel file.",
    accent: "#13294B",
    border: "rgba(19,41,75,0.15)",
    to: "/id-matching",
    live: true,
    span: 1,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" style={{width:28,height:28}}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m5.231 13.481L15 17.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v16.5c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Zm3.75 11.625a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
      </svg>
    ),
  },
  {
    label: "Time Tracking",
    description: "Weekly timesheet submission for student workers with supervisor approval and HR oversight.",
    accent: "#3B82F6",
    border: "rgba(59,130,246,0.2)",
    live: false,
    span: 1,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" style={{width:28,height:28}}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
      </svg>
    ),
  },
  {
    label: "Membership Pass Console",
    description: "Issue digital UIAA membership passes via Apple Wallet and Google Wallet.",
    accent: "#10B981",
    border: "rgba(16,185,129,0.2)",
    live: false,
    span: 1,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" style={{width:28,height:28}}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z" />
      </svg>
    ),
  },
  {
    label: "Project/Data Requests",
    description: "Create a new project with Marketing or submit data/IT/access requests to AIS.",
    accent: "#8B5CF6",
    border: "rgba(139,92,246,0.2)",
    live: false,
    span: 1,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" style={{width:28,height:28}}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
      </svg>
    ),
  },
];

function FeatureCard({ item }) {
  const navigate = useNavigate();
  const clickable = item.live && item.to;

  return (
    <div
      onClick={() => clickable && navigate(item.to)}
      style={{
        gridColumn: `span ${item.span}`,
        padding: "28px",
        borderRadius: "20px",
        background: "white",
        border: `1px solid ${item.border}`,
        boxShadow: "0 1px 4px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.04)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: "160px",
        cursor: clickable ? "pointer" : "default",
        transition: "transform 0.15s ease, box-shadow 0.15s ease",
        position: "relative",
        overflow: "hidden",
      }}
      onMouseEnter={e => {
        if (clickable) {
          e.currentTarget.style.transform = "translateY(-2px)";
          e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.08), 0 12px 32px rgba(0,0,0,0.08)";
        }
      }}
      onMouseLeave={e => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.04)";
      }}
    >
      {/* Subtle accent line at top */}
      <div style={{
        position: "absolute", top: 0, left: 0, right: 0, height: "3px",
        background: item.accent, borderRadius: "20px 20px 0 0"
      }} />

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <div style={{
          width: 48, height: 48, borderRadius: 14,
          background: `${item.accent}12`,
          display: "flex", alignItems: "center", justifyContent: "center",
          color: item.accent,
        }}>
          {item.icon}
        </div>
        <span style={{
          fontSize: 10, fontWeight: 700, letterSpacing: "0.08em",
          textTransform: "uppercase",
          color: item.live ? item.accent : "#9ca3af",
          background: item.live ? `${item.accent}12` : "#f3f4f6",
          padding: "4px 10px", borderRadius: 999,
        }}>
          {item.live ? "Live" : "Coming Soon"}
        </span>
      </div>

      <div style={{ marginTop: 20 }}>
        <p style={{ fontWeight: 700, fontSize: 15, color: "#111827", marginBottom: 5 }}>
          {item.label}
        </p>
        <p style={{ fontSize: 12, color: "#6b7280", lineHeight: 1.6 }}>
          {item.description}
        </p>
        {clickable && (
          <p style={{ fontSize: 11, color: item.accent, fontWeight: 600, marginTop: 10 }}>
            Open →
          </p>
        )}
      </div>
    </div>
  );
}

export default function Home() {
  const [firstName, setFirstName] = useState("");

  useEffect(() => {
    fetchUserAttributes()
      .then(a => setFirstName(a.name || ""))
      .catch(() => {});
  }, []);

  return (
    <div style={{ maxWidth: 1100, margin: "0 auto" }}>

      {/* Header — centered */}
      <div style={{ textAlign: "center", marginBottom: 48 }}>
        <p style={{
          fontSize: 11, fontWeight: 600, color: "#9ca3af",
          letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 12
        }}>
          {today}
        </p>
        <h1 style={{
          fontSize: 72, fontWeight: 800, color: "#111827",
          marginBottom: 12, lineHeight: 1.1
        }}>
          {getGreeting()}{firstName ? `, ${firstName}` : ""} 👋
        </h1>
        <p style={{ fontSize: 16, color: "#6b7280" }}>
          Welcome to Project (217) — UIAA's internal operations portal.
        </p>
      </div>

      {/* Section label */}
      <p style={{
        fontSize: 11, fontWeight: 700, color: "#9ca3af",
        letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 16
      }}>
        Portal Features
      </p>

      {/* Bento grid — 3 columns */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 16 }}>
        {features.map(item => <FeatureCard key={item.label} item={item} />)}
      </div>

      {/* Footer */}
      <div style={{ marginTop: 48, paddingTop: 24, borderTop: "1px solid #f3f4f6", textAlign: "center" }}>
        <p style={{ fontSize: 11, color: "#d1d5db" }}>
          University of Illinois Alumni Association · Alumni Information Services · 2026
        </p>
      </div>
    </div>
  );
}